<div class="gc-email-viewer">
  <div class="email-header">
    <div class="email-header-subject" [attr.data-automation-id]="'gc-email-header-subject'">
      {{ emailMessage.subject }}
    </div>
    <div class="email-header-details">
      <div class="email-header-details-visible-row">
        <div class="email-header-details-left">
          <div class="email-header-started" [attr.data-automation-id]="'gc-email-header-started'">
            {{ getFormattedTime(emailMessage.time) }}
          </div>
          <app-copy-text-to-clipboard
            class="copy-text-link"
            [linkText]="'genesysEmailViewer.copyEmailThreadId' | translate"
            [textToCopy]="emailMessage.id"
          >
          </app-copy-text-to-clipboard>
        </div>
        <a
          class="email-header-details-toggle"
          target="_blank"
          tabindex="0"
          (keyup.enter)="toggleMoreDetails()"
          (click)="toggleMoreDetails()"
          [attr.data-automation-id]="'gc-email-header-details-toggle'"
        >
          <span *ngIf="detailsExpanded">{{ 'genesysEmailViewer.details.collapse' | translate }}</span>
          <span *ngIf="!detailsExpanded">{{ 'genesysEmailViewer.details.expand' | translate }}</span>
        </a>
      </div>
      <div class="email-header-recipient" [hidden]="!detailsExpanded">
        <div>
          <div class="recipient-label" [attr.data-automation-id]="'gc-email-header-from-label'">
            {{ 'genesysEmailViewer.recipient.from' | translate }}
          </div>
          <div class="recipient-value" [attr.data-automation-id]="'gc-email-header-from-value'">
            {{ getFormattedEmailAddress(emailMessage.from) }}
          </div>
        </div>
        <div *ngIf="hasEmailAddress(emailMessage.to)">
          <div class="recipient-label">{{ 'genesysEmailViewer.recipient.to' | translate }}</div>
          <div class="recipient-value">{{ getFormattedEmailAddresses(emailMessage.to) }}</div>
        </div>
        <div *ngIf="hasEmailAddress(emailMessage.cc)">
          <div class="recipient-label">{{ 'genesysEmailViewer.recipient.cc' | translate }}</div>
          <div class="recipient-value" [attr.data-automation-id]="'gc-email-header-cc-value'">
            {{ getFormattedEmailAddresses(emailMessage.cc) }}
          </div>
        </div>
      </div>
    </div>
    <app-genesys-email-attachments
      *ngIf="emailMessage.attachments.length"
      [attachments]="emailMessage.attachments"
    ></app-genesys-email-attachments>
  </div>
  <div class="gc-email-body">
    <app-genesys-secure-frame
      [content]="emailMessage | gcEmailBody"
      [frameId]="emailMessage.id"
    ></app-genesys-secure-frame>
  </div>
</div>
